export default __webpack_public_path__ + "static/tooltip-contents-dont-dark-3a16431738b40d1615c017f187b4216d.png";